import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC, ReactNode } from 'react';
import { Person, PersonColumnBox, PersonColumnBoxWithImage, PersonName, PersonTextField } from './ContactPersonStyle';

interface ContactPersonProps {
    contactPersonData: any;
    currentDistributorCode?: string;
}

const ContactPerson: FC<ContactPersonProps> = ({ contactPersonData, currentDistributorCode }) => {
    const { t } = useTranslation();
    const distibutorCodes = ['pg', 'fj'];

    const checkIfPageAddressIsCorrect = (path: string): string => {
        if (path.includes('https')) {
            return path;
        } else if (path.includes('http')) {
            return path.replace('http', 'https');
        } else {
            return path.replace(path, `https://${path}`);
        }
    };

    const checkIfPersonHasPicture = (): ReactNode =>
        contactPersonData?.attachments?.admPhoto0 ? (
            <PersonColumnBoxWithImage>
                <img src={contactPersonData.attachments.admPhoto0} alt="person_foto" />
                <PersonName isPicture={true} dangerouslySetInnerHTML={{ __html: contactPersonData?.Name }}></PersonName>
            </PersonColumnBoxWithImage>
        ) : (
            <PersonColumnBox>
                {(contactPersonData?.hasOwnProperty('Name') || contactPersonData?.hasOwnProperty('name')) && (
                    <PersonTextField
                        dangerouslySetInnerHTML={{ __html: contactPersonData?.Name ?? contactPersonData?.name }}
                    ></PersonTextField>
                )}
                {(contactPersonData?.hasOwnProperty('Street') || contactPersonData?.hasOwnProperty('street')) && (
                    <PersonTextField
                        dangerouslySetInnerHTML={{ __html: contactPersonData.Street ?? contactPersonData.street }}
                    ></PersonTextField>
                )}
                {(contactPersonData?.hasOwnProperty('ZIP') ||
                    contactPersonData?.hasOwnProperty('zip') ||
                    contactPersonData?.hasOwnProperty('City') ||
                    contactPersonData?.hasOwnProperty('city')) &&
                distibutorCodes.includes(currentDistributorCode) ? (
                    <>
                        <PersonTextField>{contactPersonData.ZIP ?? contactPersonData.zip} </PersonTextField>
                        <PersonTextField>{contactPersonData.City ?? contactPersonData.city}</PersonTextField>
                    </>
                ) : (
                    <PersonTextField>
                        {contactPersonData.ZIP ?? contactPersonData.zip}{' '}
                        {contactPersonData.City ?? contactPersonData.city}
                    </PersonTextField>
                )}
            </PersonColumnBox>
        );

    return (
        <Person>
            {checkIfPersonHasPicture()}
            <PersonColumnBox>
                {(contactPersonData?.hasOwnProperty('Fon') || contactPersonData?.hasOwnProperty('phone')) &&
                    (contactPersonData?.Fon?.length > 0 || contactPersonData?.phone?.length > 0) && (
                        <PersonTextField>
                            {t('phone')}:{' '}
                            <a href={`tel:${contactPersonData.Fon ?? contactPersonData.phone}`}>
                                {contactPersonData.Fon ?? contactPersonData.phone}
                            </a>
                        </PersonTextField>
                    )}
                {(contactPersonData?.hasOwnProperty('Fax') || contactPersonData?.hasOwnProperty('fax')) &&
                    (contactPersonData?.Fax?.length > 0 || contactPersonData?.fax?.length > 0) && (
                        <PersonTextField>
                            Fax:{' '}
                            <a href={`tel:${contactPersonData.Fax ?? contactPersonData.fax}`}>
                                {contactPersonData.Fax ?? contactPersonData.fax}
                            </a>
                        </PersonTextField>
                    )}
            </PersonColumnBox>
            <PersonColumnBox>
                {(contactPersonData?.hasOwnProperty('Email') ||
                    contactPersonData?.hasOwnProperty('email') ||
                    contactPersonData?.hasOwnProperty('E-Mail')) &&
                    (contactPersonData?.Email?.length > 0 ||
                        contactPersonData?.email?.length > 0 ||
                        contactPersonData?.['E-Mail']?.length > 0) && (
                        <PersonTextField>
                            Email:{' '}
                            <a
                                href={`mailto:${
                                    contactPersonData.Email ?? contactPersonData.email ?? contactPersonData['E-Mail']
                                }`}
                            >
                                {contactPersonData.Email ?? contactPersonData.email ?? contactPersonData['E-Mail']}
                            </a>
                        </PersonTextField>
                    )}
                {contactPersonData?.www?.length > 0 && (
                    <PersonTextField>
                        Web:{' '}
                        <a href={checkIfPageAddressIsCorrect(contactPersonData.www)} target="_blank">
                            {contactPersonData.www}
                        </a>
                    </PersonTextField>
                )}
            </PersonColumnBox>
        </Person>
    );
};

export default ContactPerson;
